import { Typography } from '@analytical-alley/ui';
import React from 'react';

export const MediaInvestmentTooltipContent = ({
    formatNumber,
    totalRecommendedBudget,
    previousPeriodInvestmentTotal,
}: {
    formatNumber: (val: number) => string;
    totalRecommendedBudget: number;
    previousPeriodInvestmentTotal: number;
}) => {
    const budgetAbsDiff =
        totalRecommendedBudget - previousPeriodInvestmentTotal;
    const budgetPercentageDiff =
        Math.round(
            (budgetAbsDiff / previousPeriodInvestmentTotal) * 100 * 100,
        ) / 100;

    return (
        <table>
            <tbody>
                <tr>
                    <td className="pr-2">
                        <Typography className="text-black dark:text-black">
                            Recommended Budget:
                        </Typography>
                    </td>
                    <td className="pr-2">
                        <Typography className="text-dark dark:text-dark">
                            {formatNumber(totalRecommendedBudget)}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <td className="pr-2">
                        <Typography className="text-black dark:text-black">
                            Previous Budget:
                        </Typography>
                    </td>
                    <td className="pr-2">
                        <Typography className="text-dark dark:text-dark">
                            {formatNumber(previousPeriodInvestmentTotal)}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <td className="pr-2">
                        <Typography className="text-black dark:text-black">
                            Change:
                        </Typography>
                    </td>
                    <td className="pr-2">
                        <Typography className="text-dark dark:text-dark">
                            {budgetPercentageDiff}% /{' '}
                            {formatNumber(budgetAbsDiff)}
                        </Typography>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
